import { EventStatusTypes } from '__generated__/graphql/legacy/graphql';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';

import React from 'react';

import EmptyState from '../EmptyState';
import styles from './NoEventEmptyState.module.scss';

const cx = classNames.bind(styles);

interface NoEventEmptyStateProps {
  eventStatus: EventStatusTypes;
}

const NoEventEmptyState: React.FC<NoEventEmptyStateProps> = ({ eventStatus }) => {
  const { t } = useTranslation();
  const isPastEvent = eventStatus === EventStatusTypes.Expired;

  return (
    <>
      {isPastEvent ? (
        <div className={cx('no-event-empty-state__container')}>
          <span>{t('components-events-no_past_events', 'No previous events to display.')}</span>
        </div>
      ) : (
        <EmptyState />
      )}
    </>
  );
};

export default NoEventEmptyState;
